import styled from "styled-components";

export const ContainerFilaVirtualMasInfoCasa = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: transparent;
`;

export const FilaVirtualMasInfoCasaTitulo = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  text-align: center;
`;

export const FilaVirtualMasInfoCasaIcono = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
  text-align: center;
`;
export const FilaVirtualMasInfoCasaTxt = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
  text-align: center;
`;
export const FilaVirtualMasInfoCasaConoceMasTxt = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-top: 36px;
  .FilaVirtualMasInfoCasaConoceMasTxt {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const FilaVirtualMasInfoCasaBotones = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
